<template>
  <div>
    <CollapsibleCard
      :value="true"
      collapsibleIcon="mdi-order-bool-ascending-variant"
      collapsibleTitle="Aktiviteter"
      :padding="false"
    >
      <template v-slot>
        <v-list color="cardSurface">
          <v-list-group
            v-for="(activity, index) in activitiesData"
            :key="index"
            v-model="activity.active"
            class="measureActivityList"
          >
            <template v-slot:activator>
              <v-sheet
                class="cardStatusSideline transparent"
                :color="
                  activity.complete
                    ? activity.aberration
                      ? 'warning'
                      : 'success'
                    : ''
                "
              ></v-sheet>
              <v-list-item-content class="measureActivity-title">
                <v-list-item-title>
                  {{ index + 1 }}. {{ activity.name }}
                </v-list-item-title>
              </v-list-item-content>

              <div class="measureActivity-buttons">
                <v-list-item-action>
                  <v-btn
                    v-if="activity.complete"
                    icon
                    :ripple="false"
                    depressed
                  >
                    <v-icon
                      :color="activity.aberration ? 'warning' : 'success'"
                    >
                      mdi-check-circle
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="!activity.complete"
                    icon
                    @click.stop="done(activity)"
                  >
                    <v-icon>mdi-thumb-up-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action v-if="!$vuetify.breakpoint.xs">
                  <v-btn icon @click.stop="aberration(activity)">
                    <v-icon :color="activity.aberration ? 'warning' : 'grey'">
                      {{
                        activity.aberration ? "mdi-alert" : "mdi-alert-outline"
                      }}
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action v-if="!$vuetify.breakpoint.xs">
                  <v-btn
                    :color="activity.comment ? 'info' : 'grey'"
                    icon
                    @click.stop="comment(activity)"
                  >
                    <v-icon>
                      {{
                        activity.aberration
                          ? "mdi-comment-text-multiple"
                          : "mdi-comment-text-multiple-outline"
                      }}
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
                <!-- dots on mobile -->
                <v-list-item-action v-if="$vuetify.breakpoint.xs">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-btn icon @click.stop="aberration(activity)">
                          <v-icon
                            :color="activity.aberration ? 'warning' : 'grey'"
                          >
                            {{
                              activity.aberration
                                ? "mdi-alert"
                                : "mdi-alert-outline"
                            }}
                          </v-icon>
                        </v-btn>
                      </v-list-item>

                      <v-list-item>
                        <v-btn
                          :color="activity.comment ? 'info' : 'grey'"
                          icon
                          @click.stop="comment(activity)"
                        >
                          <v-icon>
                            {{
                              activity.aberration
                                ? "mdi-comment-text-multiple"
                                : "mdi-comment-text-multiple-outline"
                            }}
                          </v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </div>
            </template>

            <v-list-item class="pl-9">
              <v-list-item-content>
                <v-runtime-template
                  class="lineChangeLink"
                  :template="activity.text"
                ></v-runtime-template>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </template>
    </CollapsibleCard>
    <DialogText
      v-model="showCommentDialog"
      :data="commentActivity"
      title="Kommentar"
      subtitle="Legg til kommentar"
      icon="mdi-comment-text-outline"
      label="Kommentar"
      @save="saveComment"
    />
    <AddAberrationDialog
      v-model="showAberrationDialog"
      :data="newAberration"
      @save="addAberration"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import scheduleApi from "@/api/scheduleApi";

import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import DialogText from "@/components/shared/dialog/DialogText.vue";
import AddAberrationDialog from "@/components/checkups/checkup/children/AddAberrationDialog.vue";
import VRuntimeTemplate from "v-runtime-template";
import notification from "@/helpers/notification";

export default Vue.extend({
  name: "MeasureActivities",
  props: {
    activities: {
      type: Array,
    },
  },
  data: () => ({
    showCommentDialog: false,
    showAberrationDialog: false,
    commentActivity: {},
    addAberrationData: {
      attachments: [],
      aberrationTypeId: 0,
      activityId: null,
      category: 1,
      description: "",
      projTable: 0,
      title: "",
    },
    newAberration: {},
  }),
  methods: {
    async done(activity) {
      activity.complete = true;
      await scheduleApi.updateActivitie(activity).then((response) => {
        this.$emit("updateActivities", response.activities);
        notification.success("Aktivitet satt til fullført!");
      });
    },
    aberration(activity) {
      if (activity.aberration) {
        notification.warn("Avvik er allerede opprettet!");
      } else {
        this.addAberrationData.activityId = activity.id;
        // this.addAberrationData.title = "";
        // this.addAberrationData.description = "";
        // this.addAberrationData.attachments = [];
        // this.newAberration = { ...this.addAberrationData };

        this.newAberration = JSON.parse(JSON.stringify(this.addAberrationData));

        this.showAberrationDialog = true;
      }
    },
    comment(activity) {
      this.commentActivity = { ...activity };
      this.showCommentDialog = true;
    },
    async saveComment(activity) {
      await scheduleApi.updateActivitie(activity).then((response) => {
        this.$emit("updateActivities", response.activities);
        notification.success("Kommentar lagt til!");
      });
      this.showCommentDialog = false;
    },
    async addAberration(data) {
      await scheduleApi.addAberrationToActivity(data).then((response) => {
        this.$emit("updateActivities", response.activities);
        this.showAberrationDialog = false;
        notification.success("Avvik lagt til!");
      });
    },
  },
  computed: {
    activitiesData: {
      get(): Array<any> {
        return this.activities;
      },
      set(value: Array<any>) {
        this.$emit("update:activities", value);
      },
    },
  },
  components: {
    CollapsibleCard,
    DialogText,
    AddAberrationDialog,
    VRuntimeTemplate,
  },
});
</script>

<style lang="scss">
.lineChangeLink {
  max-width: 100%;
  p a {
    display: block !important;
  }
}

.measureActivityList {
  .v-list-group__header__append-icon {
    order: 0;
    margin-left: 0 !important;
    margin-right: 0.5rem !important;
    min-width: auto !important;
  }
  .measureActivity-title {
    order: 1;
  }
  .measureActivity-buttons {
    order: 2;
    .v-list-item__action {
      margin-right: 0;
      margin-left: 0.2rem !important;
    }
  }
}
</style>
